import { useContext, useEffect } from "react";
import { useRouter } from "next/router";
import { LayoutContext } from "@components/layout/Layout";
import SiteChrome from "@chrome/SiteChrome";
import { HtmlPageTitle } from "@components/HtmlPageTitle";
import { MetaDescription } from "@components/MetaDescription";
import { SiteHtmlPageTitle } from "@content/en/HtmlTitle";
import { LandingPage } from "@components/LandingPage";

const TerminalLandingPage = () => {
  const { pathname } = useRouter();
  const { REPLCollapsed, setREPLCollapsed, setREPLFullSize } =
    useContext(LayoutContext);

  // set repl full size when on the /terminal page of the site (formerly known as "notecard playground")
  useEffect(() => {
    if (pathname === "/terminal") {
      setREPLFullSize(true);
      setREPLCollapsed(false);
      const REPLCollapsedCache = REPLCollapsed;
      return () => {
        setREPLFullSize(false);
        setREPLCollapsed(REPLCollapsedCache);
      };
    }
  }, [pathname]);

  return (
    <SiteChrome>
      <HtmlPageTitle title={`In-Browser Terminal - ${SiteHtmlPageTitle}`} />
      <MetaDescription description="Notecard In-Browser Terminal." />
      <LandingPage name="terminal" />
    </SiteChrome>
  );
};

export default TerminalLandingPage;
